// API service for fetching content from the CMS backend

const API_URL = '';

// Helper function for API calls
async function fetchAPI(endpoint) {
  try {
    const response = await fetch(`${API_URL}/api/content${endpoint}`);
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Failed to fetch ${endpoint}:`, error);
    return null;
  }
}

// Content API functions
export const contentAPI = {
  // Get menu items grouped by category
  getMenu: () => fetchAPI('/menu'),
  
  // Get menu highlights for homepage
  getMenuHighlights: () => fetchAPI('/menu-highlights'),
  
  // Get gallery images
  getGallery: () => fetchAPI('/gallery'),
  
  // Get restaurant info
  getRestaurantInfo: () => fetchAPI('/restaurant-info'),
  
  // Get story/about content
  getStory: () => fetchAPI('/story'),
  
  // Get chef's table info
  getChefsTable: () => fetchAPI('/chefs-table'),
  
  // Get community initiatives
  getCommunity: () => fetchAPI('/community'),
  
  // Get private events packages
  getPrivateEvents: () => fetchAPI('/private-events'),
  
  // Get hero section content (homepage slideshow)
  getHero: () => fetchAPI('/hero'),

  // Generic page content (full pages)
  getPage: (slug) => fetchAPI(`/pages/${slug}`),

  // Site chrome
  getNav: () => fetchAPI('/nav'),
  getFooter: () => fetchAPI('/footer'),
  getNewsletterCopy: () => fetchAPI('/newsletter-copy'),
  getPress: () => fetchAPI('/press'),
  getSocialPosts: () => fetchAPI('/social-posts'),
  getVisitInfo: () => fetchAPI('/visit-info'),
  getMarketingConfig: () => fetchAPI('/marketing-config'),

  // Newsletter subscribe
  subscribeNewsletter: async (payload) => {
    try {
      const res = await fetch(`${API_URL}/api/content/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Subscription failed');
      }
      return await res.json();
    } catch (error) {
      console.error('Newsletter subscribe failed:', error);
      throw error;
    }
  },

  // Private event inquiry
  submitEventInquiry: async (payload) => {
    const res = await fetch(`${API_URL}/api/content/private-events/inquire`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.detail || 'Could not submit inquiry');
    }
    return await res.json();
  },
};

export default contentAPI;
